export const countActiveFilters = (selected) =>
  Object.values(selected).reduce((acc, arr) => acc + (arr?.length || 0), 0);

export const clearFilters = (config) =>
  Object.fromEntries(config.map((section) => [section.key, []]));
